var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScheduleCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.1 70.8",
    style: {
      enableBackground: "new 0 0 85.1 70.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.1,36.3c2.2-1.9,4-4.3,5.2-7c1.2-2.7,1.9-5.6,1.9-8.5c0-5.5-2.2-10.8-6.1-14.7C44.2,2.2,38.9,0,33.4,0 c-5.5,0-10.8,2.2-14.7,6.1c-3.9,3.9-6.1,9.2-6.1,14.7c0,2.9,0.6,5.8,1.9,8.5c1.2,2.7,3,5.1,5.2,7C13.8,39,8.9,43.2,5.4,48.6 c-3.5,5.4-5.3,11.6-5.3,18c0,1.1,0.4,2.2,1.2,2.9c0.8,0.8,1.8,1.2,2.9,1.2s2.2-0.4,2.9-1.2c0.8-0.8,1.2-1.8,1.2-2.9 c0-6.6,2.6-13,7.3-17.7s11-7.3,17.7-7.3s13,2.6,17.7,7.3s7.3,11,7.3,17.7c0,1.1,0.4,2.2,1.2,2.9s1.8,1.2,2.9,1.2 c1.1,0,2.2-0.4,2.9-1.2c0.8-0.8,1.2-1.8,1.2-2.9c0-6.4-1.9-12.7-5.3-18C57.9,43.2,53,39,47.1,36.3z M33.4,33.3 c-2.5,0-4.9-0.7-6.9-2.1c-2.1-1.4-3.7-3.3-4.6-5.6s-1.2-4.8-0.7-7.2c0.5-2.4,1.7-4.7,3.4-6.4c1.7-1.7,4-2.9,6.4-3.4 c2.4-0.5,4.9-0.2,7.2,0.7c2.3,0.9,4.2,2.5,5.6,4.6s2.1,4.5,2.1,6.9c0,3.3-1.3,6.5-3.7,8.8S36.7,33.3,33.4,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1,39.1h6.7V15.8h-6.7V39.1z M78.4,15.8v23.3h6.7V15.8H78.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleCreate);
export default __webpack_public_path__ + "static/media/icon_schedule_create.281c18ee45ef0e9315e0f2ee645dc14d.svg";
export { ForwardRef as ReactComponent };